import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/configuration/crawl")({
	beforeLoad: () => {
		throw redirect({ to: "/crawl/settings" })
	},
})
